import { withApolloClient } from '../decorators';
export const decorators = [withApolloClient];
//# sourceMappingURL=addDecorator.js.map